import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import QrCodeIcon from "@material-ui/icons/CropFree";

import { ModalGeneral } from "@components/ModalGeneral/ModalGeneral";
import PixPaymentPanel from "./PixPaymentPanel";
import { useFlags } from "flagsmith/react";
import { PixPayload } from "../models/IPixPayment";
import { Typography } from "@mui/material";

type Props = {
  openLabel?: string;
  title?: string;
  razaoSocial: string;
  produto: string;
  valorTotal?: number;
  payCond?: number;
  payloads: PixPayload[];
  disabledReason?: string;
  loading?: boolean;
  error?: string | null;
};

const PixMobileModel: React.FC<Props> = ({
  openLabel = "Pagar com Pix",
  title = "Pagamento via Pix",
  razaoSocial,
  produto,
  valorTotal = 0,
  payCond,
  payloads,
  disabledReason = "Disponível apenas para pagamento à vista",
  loading,
  error,
}) => {
  const [open, setOpen] = React.useState(false);
  const { pix_method_paycond } = useFlags(["pix_method_paycond"]);

  const isEnabled = Boolean(pix_method_paycond?.enabled) && payCond === 0;

  const ModalContent = () => {
    if (error) {
      return (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <Typography color="error" variant="h6">
            Erro ao carregar PIX
          </Typography>
          <Typography variant="body1">{error}</Typography>
        </div>
      );
    }

    return (
      <PixPaymentPanel
        razaoSocial={razaoSocial}
        produto={produto}
        valorTotal={valorTotal}
        payCond={payCond}
        payloads={payloads}
        loading={loading || false}
      />
    );
  };

  return (
    <>
      <Tooltip title={isEnabled ? openLabel : disabledReason}>
        <span>
          <IconButton
            size="small"
            color="primary"
            onClick={() => isEnabled && setOpen(true)}
            disabled={!isEnabled}
            aria-label="abrir pagamento Pix"
          >
            <QrCodeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <ModalGeneral
        open={open}
        closeModal={() => setOpen(false)}
        titleHeaderModal={title}
        resetPadding={false}
        width="100%"
        height="auto"
      >
        <ModalContent />
      </ModalGeneral>
    </>
  );
};

export default PixMobileModel;
